// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3hxaK","tab":"Tabs_tab__3pllE","tabActive":"Tabs_tabActive__3YUL0"};